var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hero-banner",attrs:{"data-external":"hero-banner"}},[_c(_vm.component,{tag:"component",attrs:{"link":_vm.sanitizedLink}},[_c('BaseBanner',{attrs:{"title":_vm.title,"description":_vm.description,"banner-image":_vm.bannerImage,"banner-image-mobile":_vm.bannerImageMobile,"size":_vm.size}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }